import { render, staticRenderFns } from "./legendBox7.vue?vue&type=template&id=e7564ca4&scoped=true&"
import script from "./legendBox7.vue?vue&type=script&lang=js&"
export * from "./legendBox7.vue?vue&type=script&lang=js&"
import style0 from "./legendBox7.vue?vue&type=style&index=0&id=e7564ca4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7564ca4",
  null
  
)

export default component.exports